<template>
    <div class="box center unset">
        <!-- 筛选器 -->
        <div class="label">
            <p
                :class="rankBy === 'day' ? 'selected' : ''"
                @click="() => selectRankBy('day')"
            >
                按天
            </p>
            <p
                :class="rankBy === 'week' ? 'selected' : ''"
                @click="() => selectRankBy('week')"
            >
                按周
            </p>
            <p
                :class="rankBy === 'month' ? 'selected' : ''"
                @click="() => selectRankBy('month')"
            >
                按月
            </p>
        </div>
        <!-- 我的排名 -->
        <div class="flex center flexCenter">
            <div class="avatarContainer">
                <img :src="userInfo.headUrl ? 
                userInfo.headUrl :
                '../../../static/img/default.png'" alt="">
            </div>
            <p class="myRank">我的排名：{{ ownRank.ranking ? ownRank.ranking : `${ownRank.overRanking} +` }}</p>
        </div>
        <!-- 排行榜前三名 -->
        <div class="flex rank" v-if="topProfit.length > 0">
            <div class="No2">
                <p class="rankIcon">
                    <svg class="icon" aria-hidden="true" slot="icon">
                        <use xlink:href="#icon-No2"></use>
                    </svg>
                </p>
                    <img :src="
                        topProfit.length > 1 && users.find(s => s.id === topProfit[1].convergeKey) ? 
                        users.find(s => s.id === topProfit[1].convergeKey).headUrl : 
                        '../../../static/img/default.png'
                    " alt="">
                <p class="rankNum2">2</p>
                <p class="character">{{
                    topProfit.length > 1 && users.find(s => s.id === topProfit[1].convergeKey) ? 
                    users.find(s => s.id === topProfit[1].convergeKey).nick : 
                    '无'
                }}</p>
                <p class="rankSum">{{
                    topProfit.length > 1 && (topProfit[1].sum / 100).toFixed(2) || 0.00
                }}</p>
            </div>
            <div class="No1">
                <p class="rankIcon">
                    <svg class="icon" aria-hidden="true" slot="icon">
                        <use xlink:href="#icon-No1"></use>
                    </svg>
                </p>
                    <img :src="
                        topProfit.length > 0 && users.find(s => s.id === topProfit[0].convergeKey) ? 
                        users.find(s => s.id === topProfit[0].convergeKey).headUrl : 
                        '../../../static/img/default.png'
                    " alt="">
                <p class="rankNum1">1</p>
                <p class="character">{{
                    topProfit.length > 0 && users.find(s => s.id === topProfit[0].convergeKey) ? 
                    users.find(s => s.id === topProfit[0].convergeKey).nick : 
                    '无'    
                }}</p>
                <p class="rankSum">{{
                    topProfit.length > 0 && (topProfit[0].sum / 100).toFixed(2) || 0.00
                }}</p>
            </div>
            <div class="No3">
                <p class="rankIcon">
                    <svg class="icon" aria-hidden="true" slot="icon">
                        <use xlink:href="#icon-No"></use>
                    </svg>
                </p>
                    <img :src="
                        topProfit.length > 2 && users.find(s => s.id === topProfit[2].convergeKey) ? 
                        users.find(s => s.id === topProfit[2].convergeKey).headUrl : 
                        '../../../static/img/default.png'
                    " alt="">
                <p class="rankNum3">3</p>
                <p class="character">{{
                    topProfit.length > 2 && users.find(s => s.id === topProfit[2].convergeKey) ? 
                    users.find(s => s.id === topProfit[2].convergeKey).nick : 
                    '无'    
                }}</p>
                <p class="rankSum">{{
                    topProfit.length > 2 && (topProfit[2].sum / 100).toFixed(2) || 0.00
                }}</p>
            </div>
        </div>
        <!-- 无数据 -->
        <div v-if="topProfit.length === 0" class="empty">
            <p class='nodata'>暂无更多信息</p>
            <p class='nodata'>刷新重试</p>
        </div>
    </div>
</template>

<script>

export default {
  props: ['users', 'topProfit', 'rankBy', 'nexus', 'selectRankBy', 'userInfo', 'ownRank'],
  name: 'Header',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.label {
    display: flex;
    margin-left: .2rem;
    margin-right: .2rem;
}
.label p {
    font-size: .16rem;
    padding: 0.02rem .1rem;
    color: #fff;
    border: 1px solid #fff;
    width: 100%;
}
.label p:nth-child(1) {
    border-right: none !important;
    border-radius: .05rem 0 0 .05rem;
}
.label p:nth-child(3) {
    border-left: none !important;
    border-radius: 0 .05rem .05rem 0;
}
.selected {
    color: #009688 !important;
    background: #fff;
}
.avatarContainer {
    height: .3rem;
    width: .3rem;
    border-radius: 50%;
    overflow: hidden;
}
.avatarContainer img {
    width: 100%;
    height: 100%;
}
.flexCenter {
    justify-content: center;
    margin-top: .1rem;
}
.flexCenter {
    line-height: .19rem;
}
.unset {
    height: 2.5rem !important;
}
.No1 {
    display: block;
}
.No1 svg {
    width: .4rem;
}
.No2 {
    display: block;
}
.No3 {
    display: block;
}
.No1 img {
    width: .8rem;
    height: .8rem;
    border-radius: 50%;
    border: 3px solid #fff;
    box-sizing: border-box;
}
.No2 img {
    width: .6rem;
    height: .6rem;
    border-radius: 50%;
    border: 3px solid #fff;
    box-sizing: border-box;
}
.No3 img {
    width: .6rem;
    height: .6rem;
    border-radius: 50%;
    border: 3px solid #fff;
    box-sizing: border-box;
}
.No1 p {
    color: #fff;
    margin-top: 2px;
    word-break: keep-all;
}
.No2 p {
    color: #fff;
    margin-top: 2px;
    word-break: keep-all;
}
.No3 p {
    color: #fff;
    margin-top: 2px;
    word-break: keep-all;
}
.rank {
    display: box;              /* OLD - Android 4.4- */
    display: -webkit-box;      /* OLD - iOS 6-, Safari 3.1-6 */
    display: -moz-box;         /* OLD - Firefox 19- (buggy but mostly works) */
    display: -ms-flexbox;      /* TWEENER - IE 10 */
    display: -webkit-flex;     /* NEW - Chrome */
    display: flex; 
    justify-content: space-around;
    align-items: flex-end;
}
.rankIcon {
    position: relative;
    bottom: -.07rem;
}
.rankNum2 {
    color: #000 !important;
    background: #D8D8D8;
    width: .2rem;
    border-radius: 50%;
    height: 0.2rem;
    margin: auto;
    position: relative;
    bottom: .12rem;

}
.rankNum1 {
    color: #000  !important;
    background: #FFDC07;
    width: .2rem;
    border-radius: 50%;
    height: 0.2rem;
    margin: auto;
    position: relative;
    bottom: .12rem;

}
.rankNum3 {
    color: #000  !important;
    background: #D9AD7A;
    width: .2rem;
    border-radius: 50%;
    height: 0.2rem;
    margin: auto;
    position: relative;
    bottom: .12rem;
}
.character {
    width: .9rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: .16rem;
    margin-bottom: 5px;
}
.No1circle {
    padding: 3px;
    border-radius: 50%;
    padding-top: 5px;
    background: #fff;
}
.myRank {
    margin-left: 5px;
    position: relative;
    top: .05rem;
    font-size: .14rem;
}
.rankSum {
    font-size: .15rem;
}
.empty {
    margin-top: .71rem;
}
.nodata {
    color: #fff;
    margin-top: .1rem;
    font-size: 10pt;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/userRankElement/Header.vue